import axios from 'axios';

let apiEndpoint = process.env.VUE_APP_API_BASEURL

export default {
    register(formData) {
        // Sending formData using multipart/form-data
        return axios.post(`${apiEndpoint}/contractor/register`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        });
    },
    async checkEmail(emailAddress) {
        return await axios.post(`${apiEndpoint}/contractor/checkAvailableEmail`, { email: emailAddress }, {
            headers: {
                'Content-Type': 'application/json',
            }
        });
    },
    async updateContractorProfile(profileData) {
        const isFormData = typeof FormData !== 'undefined' && profileData instanceof FormData;
        const headers = {
            'Authorization': 'Bearer ' + localStorage.getItem('contractorToken'),
        };
        if (!isFormData) {
            headers['Content-Type'] = 'application/json';
        }
        return axios.post(`${apiEndpoint}/contractor/update-profile`, profileData, { headers });
    },
    async getJobs() {
        return axios.get(`${apiEndpoint}/contractor/get-jobs`, {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('contractorToken'),
            }
        });
    },
    async getJob(jobId) {
        return axios.get(`${apiEndpoint}/contractor/get-job/` + jobId, {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('contractorToken'),
            }
        });
    },
    async applyJob(jobId, rate, rate_type) {
        return await axios.post(`${apiEndpoint}/contractor/apply-job`, { jobId: jobId, rate: rate, rate_type: rate_type }, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('contractorToken'),
            }
        });
    },
    async getApplications() {
        return axios.get(`${apiEndpoint}/contractor/get-applications`, {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('contractorToken'),
            }
        });
    },
    async getResume() {
        return axios.get(`${apiEndpoint}/contractor/get-resume`, {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('contractorToken'),
            },
            responseType: 'blob'  // Tell Axios to treat the response as a Blob
        });
    },
    async getAnswers() {
        return axios.get(`${apiEndpoint}/contractor/get-answers`, {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('contractorToken'),
            }
        });
    },
    async getExpertise() {
        return axios.get(`${apiEndpoint}/contractor/get-expertise`, {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('contractorToken'),
            }
        });
    },
    async getCareerHighlights() {
        return axios.get(`${apiEndpoint}/contractor/get-career-highlights`, {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('contractorToken'),
            }
        });
    },
    async getRemuneration() {
        return axios.get(`${apiEndpoint}/contractor/get-remuneration`, {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('contractorToken'),
            }
        });
    },
    async updateContractorSettings(data) {
        return axios.post(`${apiEndpoint}/contractor/update-settings`, data, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('contractorToken'),
            }
        });
    },
    async updateContractorProfilePicture(formData) {
        return axios.post(`${apiEndpoint}/contractor/update-settings`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': 'Bearer ' + localStorage.getItem('contractorToken'),
            }
        });
    },
    async getDescription() {
        return axios.post(`${apiEndpoint}/contractor/get-description`, {}, {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('contractorToken'),
            }
        });
    },
    async removeAIDescription() {
        return axios.post(`${apiEndpoint}/contractor/remove-description`, {}, {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('contractorToken'),
            }
        });
    },
    async updateAIDescription(description) {
        return axios.post(`${apiEndpoint}/contractor/update-description`, { description }, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('contractorToken'),
            }
        });
    },
    async getUploads() {
        return axios.get(`${apiEndpoint}/contractor/get-uploads`, {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('contractorToken'),
            }
        });
    },
    updateResume(formData) {
        // Sending formData using multipart/form-data
        return axios.post(`${apiEndpoint}/contractor/update-resume`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': 'Bearer ' + localStorage.getItem('contractorToken'),
            }
        });
    },
}
